import React from "react";

export const PopUpContent = ({
  contentTitle,
  contentText,
  contentUrl,
  contentButtonText,
}) => (
  <div className="popup-modal__content">
    <div className="popup-modal__content-card">
      <div className="popup-modal__content-card_text">
        <h2>{contentTitle}</h2>
        <p>{contentText}</p>
      </div>
      <button>
        <a href={contentUrl} target="_blank">
          {contentButtonText}
        </a>
      </button>
    </div>
  </div>
);
